// Path: ./src/app/components/PermissionComponentWrapper/index.tsx
import React from "react";
import styled from "styled-components";
import { GoFlyerAdminContext } from "../../../contextApi/context";
import { SUPERADMIN } from "../../../utils/constant/stringConstant";

interface PermissionComponentProps {
  requiredPermission?: string[];
  children: React.ReactNode;
  requiredPermissionGroup?: string[];
  wrapperCss?: string;
}

interface WrapperProps {
  wrapperCss?: string;
}
const ContentWrapper = styled.div<WrapperProps>`
  ${(props) => {
    return props?.wrapperCss ? props.wrapperCss : "  display: inline-block;";
  }}
`;

export const PermissionComponentWrapper: React.FC<PermissionComponentProps> = ({
  requiredPermission,
  children,
  requiredPermissionGroup,
  wrapperCss,
}) => {
  const { state } = React.useContext(GoFlyerAdminContext);

  const hasPermission =
    state.user?.parsedRoles?.name !== SUPERADMIN
      ? requiredPermissionGroup?.some((requiredGroup) =>
          state.user?.parsedRoles?.permissions?.some(
            (group) =>
              group.groupName === requiredGroup &&
              requiredPermission?.some((requiredPermission) =>
                group.permissions.some(
                  (permission) =>
                    permission.name === requiredPermission &&
                    permission.allowed,
                ),
              ),
          ),
        )
      : true;

  return hasPermission ? (
    <ContentWrapper wrapperCss={wrapperCss}>{children}</ContentWrapper>
  ) : (
    <></>
  );
};
